module.exports = __WEBPACK_EXTERNAL_MODULE__openhps_rdf__;